import { ROUTES } from "../../components/Routes/routes";
import { ROLES } from "./role-details";

const {
  RACK_FEATURES,
  RACK_PRICING,
  BID_PRICING,
  BID_FEATURES,
  REPORTS,
  SETUP,
  home,
  rackFeatures,
  rackPricingFeatures,
  bidPricingFeatures,
  bidFeatures,
  reports,
  setup,
  quartz,
  logs
} = ROUTES;

// Page-level permissions
export const PAGE_PERMISSIONS = {
  // Rack Pricing
  [RACK_PRICING.verify]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS, ROLES.ANALYST, ROLES.VIEWER],
  [RACK_PRICING.rackPricing]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP],
  [RACK_PRICING.rackConfirmation]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP],
  [RACK_PRICING.rackConfirmationWeekendHoliday]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP],
  [RACK_PRICING.benchmarkEntry]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [RACK_PRICING.wetMove]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS],
  [RACK_PRICING.dtnUpload]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP],
  [RACK_PRICING.rackPricingWeekendHoliday]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP],

  // Rack Features
  [RACK_FEATURES.allocation]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.OPERATIONS],
  [RACK_FEATURES.outage]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS],
  [RACK_FEATURES.rackDefinition]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [RACK_FEATURES.formula]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [RACK_FEATURES.terminalGroup]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [RACK_FEATURES.rackNote]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP],
  [RACK_FEATURES.rackPricingGroup]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [RACK_FEATURES.salesRep]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [RACK_FEATURES.customerRackEmail]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS],
  [RACK_FEATURES.customerRackSelection]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [RACK_FEATURES.formulaOPIS]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [RACK_FEATURES.rackMessaging]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP],

  // Bid Pricing
  [BID_PRICING.bidPricing]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP],
  [BID_PRICING.bidConfirmation]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP],

  // Bid Features
  [BID_FEATURES.bidDefinition]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [BID_FEATURES.bidFreight]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [BID_FEATURES.customerPricingSetup]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [BID_FEATURES.bidTerminalGroup]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [BID_FEATURES.customerBidEmail]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],

  // Reports (all roles have access)
  [reports]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS, ROLES.ANALYST, ROLES.VIEWER],
  [REPORTS.bidPriceFloor]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS, ROLES.ANALYST, ROLES.VIEWER],
  [REPORTS.customerBidPricing]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS, ROLES.ANALYST, ROLES.VIEWER],
  [REPORTS.opisLowReport]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS, ROLES.ANALYST, ROLES.VIEWER],
  [REPORTS.customerContractReport]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS, ROLES.ANALYST, ROLES.VIEWER],
  [REPORTS.rackPricingReport]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS, ROLES.ANALYST, ROLES.VIEWER],
  [REPORTS.bidPricingReport]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS, ROLES.ANALYST, ROLES.VIEWER],
  [REPORTS.rackContractReport]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS, ROLES.ANALYST, ROLES.VIEWER],
  [REPORTS.customerTerminalReport]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS, ROLES.ANALYST, ROLES.VIEWER],
  [REPORTS.sumnerCountyReport]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS, ROLES.ANALYST, ROLES.VIEWER],
  [REPORTS.transportPickListReport]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS, ROLES.ANALYST, ROLES.VIEWER],
  [REPORTS.productSupplyReport]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS, ROLES.ANALYST, ROLES.VIEWER],
  [REPORTS.bidMarginReport]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS, ROLES.ANALYST, ROLES.VIEWER],
  [REPORTS.pdiCostMarginReport]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS, ROLES.ANALYST, ROLES.VIEWER],
  [REPORTS.fastRacksReport]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS, ROLES.ANALYST, ROLES.VIEWER],

  // Setup
  [SETUP.calendarSchedule]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [SETUP.customer]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [SETUP.dtnCity]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [SETUP.fastRacks]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [SETUP.fuelSupplier]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [SETUP.fuelSupplierCostMap]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [SETUP.opisCity]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [SETUP.pdiPricingSetup]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [SETUP.pdiSync]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [SETUP.fuelProduct]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [SETUP.settings]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [SETUP.states]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [SETUP.tax]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [SETUP.terminal]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [SETUP.timeSetup]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [SETUP.verifyBenchmark]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [SETUP.storedProcs]: [ROLES.SYSTEM_ADMIN],

  // Monitoring & Logs
  [quartz]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [logs]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],

  // Landing pages (all authenticated users)
  [home]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS, ROLES.ANALYST, ROLES.VIEWER],
  [rackPricingFeatures]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS, ROLES.ANALYST, ROLES.VIEWER],
  [rackFeatures]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS],
  [bidPricingFeatures]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP],
  [bidFeatures]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
  [setup]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
};